import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_CLIENTS_PAGINATION_QUERY } from "@/graphql/queries/client/get-clients-pagination.query";

const client = {
  actions: {
    async getClientsQuery({ commit }, { skip, take, orderBy, query }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_CLIENTS_PAGINATION_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query,
          },
          fetchPolicy: "no-cache",
        });
      });
    },
  },
};

export default client;
